import { ref, reactive, onUnmounted } from 'vue'

export default function useTimer(timeDurationSeconds = 30) {
  let timerIntervalId = null
  const clock = reactive({
    totalTimeElapsed: 0,
    timer: {
      minutes: Math.floor(timeDurationSeconds / 60).toFixed(0),
      seconds: timeDurationSeconds % 60,
    },
  })

  const startTimer = (callback) => {
    let duration = timeDurationSeconds
    let timer = duration
    let minutes
    let seconds
    timerIntervalId = setInterval(() => {
      minutes = parseInt(timer / 60, 10)
      seconds = parseInt(timer % 60, 10)
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds
      clock.timer = {
        ...clock.timer,
        ...{ minutes, seconds },
      }
      if (--timer < 0) {
        clock.timer = duration
      }
      if (clock.totalTimeElapsed < duration) {
        clock.totalTimeElapsed++
      } else {
        callback && callback()
      }
    }, 1000)
  }

  onUnmounted(() => {
    timerIntervalId && clearInterval(timerIntervalId)
  })

  return {
    clock,
    startTimer,
  }
}
